import React, { useState } from "react";
import "../../page_content.css";

const FacultyResearch = () => {
  // for one button content shows always
  const [activeSem, setActiveSem] = useState(0);

  const FacultyResearchData = [
    {
      research: [
        // Research Papers
        {
          title: "Research Papers",
          tables: [
            [
              [
                "Title of Paper & Author/s",
                "Name of Authors",
                "Name of Journal",
                "Year of Publication",
                "ISSN Number",
                "Link To Journal",
                "Link To Article",
              ],
              [
                "UAV-Based QR Code Scanning and Inventory Synchronization System with Safe Trajectory Planning",
                "Eknath Pore, B.K.Patle Sandeep Thorat",
                "Symmetry",
                2026,
                "2073-8994",
                "https://www.mdpi.com/journal/symmetry",
                "https://www.mdpi.com/2073-8994/18/4/548#:~:text=A%20critical%20component%20of%20the,Ground%20Control%20Station%20(GCS).",
              ],
               [
                "Drone Enabled Practices in Modern Warehouse Management_ A Comprehensive Review",
                "Eknath Pore, B.K.Patle Sandeep Thorat",
                "Drones",
                2026,
                "2504-446X",
                "https://www.mdpi.com/journal/drones",
                "https://www.mdpi.com/2504-446X/10/3/189",
              ],
               [
                "Integrating Emotional Intelligence Training in Pre-Sea Programs: Enhancing Competency and Resilience of Merchant Navy Cadets",
                "Seema Hrishikesh Pundale, Dr. Namrata Kamble",
                "Integrating Emotional Intelligence Training in Pre-Sea Programs: Enhancing Competency and Resilience of Merchant Navy Cadets",
                2025,
                "ISSN: 2197-5248 https://doi.org/10.70135/seejph.vi.5022",
                "https://www.seejph.com/index.php/seejph/index",
                "https://www.seejph.com/index.php/seejph/article/view/5022",
              ], 
              [
                "Investigation on conventional and ultrasonic vibration-assisted turning of hardened steel using coated carbide tool",
                "Govind S. Ghule, Sudarshan Sanap, Satish Chinchanikar,Robert Cep,Ajay Kumar Suresh Y. Bhave Rakesh Kumar",
                "Frontiers in Mechanical Engineering",
                2024,
                "2297-3079",
                "https://www.frontiersin.org/journals/mechanical-engineering",
                "https://www.frontiersin.org/articles/10.3389/fmech.2024.1391315/abstract",
              ],
              [
                "Incident Vertex Pi Coloring of Graph Families: Fan, Book, Gear, Windmill, Dutch Windmill and Crown Graph",
                "Sunil B. Thakare, A A Bhange, H R Bhapkar",
                "Mathematics and Statistics",
                2024,
                "DOI: 10.13189/ms.2024.120408 ISSN: 2332-2144",
                "https://www.hrpub.org/journals/jour_info.php?id=34",
                "https://www.hrpub.org/journals/article_info.php?aid=14429",
              ],
              [
                "Multi-drone path planning using gradient descent and Potential fields for warehouse applications",
                "Eknath Pore, B.K.Patle, Sandeep Thorat",
                "2024 International Automatic Control Conference (CACS 2024) Longtan, Taoyuan, Taiwan, ",
                2024,
                "DOI: 10.1109/CACS63404.2024.10773359.",
                "https://iroboticsjournal.org/index.php/irobotics/announcement/view/6",
                "https://ieeexplore.ieee.org/document/10773359?denied=",
              ], 
              [
                "Enhancing Indoor Path Planning for UAV through Hybrid Artificial Intelligent Approach",
                "Eknath Pore, B.K.Patle, Sandeep Thorat",
                "2024 International Conference on Innovations and Challenges in Emerging Technologies (ICICET)",
                2024,
                "DOI: 10.1109/ICICET59348.2024.10616363.ISSN: 979-8-3503-1901-9",
                "https://ghrce.raisoni.net/icicet-24/",
                "https://ieeexplore.ieee.org/document/10616363",
              ],
              [
                "Ultrasonic vibration-assisted hard turning of AISI 52100 steel:comparative evaluation and modeling using dimensional analysis",
                "Govind S. Ghule, Sudarshan Sanap, Satish Chinchanikar",
                "Obrabotka metallov -Metal Working and Material Science",
                2023,
                "2541-819X",
                "https://journals.nstu.ru/",
                "https://journals.nstu.ru/files/articles/flash/34309_en/a/",
              ],
              [
                "Enhanced face age progression and regression model using hyper-parameter tuning-large scale GAN by hybrid heuristic improvement",
                "Tejaswini Yadav, Rajneeshkaur Sachdeo",
                "Imaging Science Journal",
                2023,
                "1368-2199",
                "https://www.tandfonline.com/journals/yims20",
                "https://www.tandfonline.com/doi/full/10.1080/13682199.2023.2254134?scroll=top&needAccess=true",
              ],
              [
                "Development of Optimal Hyper-parameter Tuning-Cycle GAN for Photo- realistic Face Age Progression Model",
                "Tejaswini Yadav,Rajneeshkaur Sachdeo",
                "International Journal on Artificial Intelligence Tools   (SCIE Journal)",
                2023,
                "1793-6349",
                "https://www.worldscientific.com/worldscinet/ijait",
                "https://www.worldscientific.com/doi/epdf/10.1142/S0218213023500689",
              ],
              [
                "Video summarization approaches in wireless capsule endoscopy : A review",
                "Dr. vrushali Rampure, Dr. Reena Gunjan",
                "E3S Web of conferences, Volume 170(2020)-Indexed in Scopus",
                2022,
                "2511-2112",
                "https://link.springer.com/journal/41870",
                "https://link.springer.com/article/10.1007/s41870-022-00894-0",
              ],
              [
                "PCCP OF CIRCULAR GRAPH FAMILY WITH A FAN GRAPH",
                "Dr A A Bhange, Dr. H R Bhapkar",
                "South east Asian Journal of Mathematics and Mathematical Sciences",
                2022,
                "0972-7752, 2582-0850",
                "https://ijeces.ferit.hr/index.php/ijeces/about",
                "https://ijeces.ferit.hr/index.php/ijeces/article/view/1165",
              ],
              [
                "Design of Super Twisting Integral Sliding Mode Control for Industrial Robot Manipulator",
                "Prof. Shankar Gambhire, D Ravi Kishore, Malligunta Kiran Kumar, Sushant N Pawar",
                "International Journal of Electrical and Computer Engineering Systems",
                2022,
                "1847-7003",
                "https://ijeces.ferit.hr/index.php/ijeces/about",
                "https://ijeces.ferit.hr/index.php/ijeces/article/view/1165",
              ],
              [
                "Robust Trajectory Tracking with Non-singular TSM Control of a Mobile Manipulator",
                "Prof. Shankar Gambhire, Dondapati Ravi Kishore, Pandurang S. Londhe, Sushant N. Pawar",
                "Bulletin of Electrical Engineering and Informatics ",
                2022,
                "2089-3191, 2302-9285",
                "https://beei.org/index.php/EEI",
                "https://beei.org/index.php/EEI/article/view/3457",
              ],
              [
                "Experimental investigations on the ultrasonic vibration-assisted hard turning of AISI 52100 steel using coated carbide tool",
                "Govind S. Ghule, Sudarshan Sanap, Sanjay Adsul, Satish Chinchanikar, Mahendra Gadge",
                "Materials Today: Proceedings",
                2022,
                "2214-7853",
                "https://www.sciencedirect.com/journal/materials-today-proceedings",
                "https://www.sciencedirect.com/science/article/abs/pii/S2214785322055432",
              ],
              [
                "A Bibliometric Analysis of Ultrasonic Vibration Assisted Turning",
                "Govind S. Ghule, Sudarshan S Sanap",
                "Library Philosophy and Practice",
                2021,
                "1522-0222",
                "https://digitalcommons.unl.edu/libphilprac/4988/",
                "https://digitalcommons.unl.edu/cgi/viewcontent.cgi?article=9254&context=libphilprac",
              ],
              [
                "Transfer learning based video summarization in wireless capsule endoscopy",
                "Dr. Vrushali Rampure, Dr. Reena Gunjan",
                "International Journal of Information Technology",
                2021,
                "2183–2190  ",
                "https://digitalcommons.unl.edu/",
                "https://link.springer.com/article/10.1007/s41870-022-00894-0",
              ],
              [
                "Review of sliding mode based control techniques for control system applications",
                "Shankar J Gambhire, D Ravi Kishore, Pandurang Londhe, S N Pawar",
                "International Journal of Dynamics and Control",
                2020,
                "2195-2698",
                "https://link.springer.com/journal/40435",
                "https://link.springer.com/article/10.1007/s40435-020-00638-7#:~:text=Sliding%20mode%20control%20technique%20is,1%2C2%2C3%5D.",
              ],
              [
                "Perfect coloring of corona product of cycle graph with cycle, path and null graph",
                "A A Bhange, H R Bhapkar",
                "Advances in Mathematics: Scientific Journal",
                2020,
                "1857-8365",
                "https://www.research-publication.com/amsj/all-issues/vol-09/iss-12",
                "https://www.research-publication.com/amsj/uploads/papers/vol-09/iss-12/AMSJ-2020-N12-68.pdf",
              ], 
              [
                "Perfect Colouring Of graphs with it’s Kinds",
                "A A Bhange, H R Bhapkar",
                "Journal of Physics: Conference Series",
                2020,
                "1742-6588, 1742-6596",
                "https://iopscience.iop.org/journal/1742-6596",
                "https://iopscience.iop.org/article/10.1088/1742-6596/1663/1/012024/meta",
              ],
              [
                "Colouring Of Graphs By HB Colour Matrix Algorithm Method",
                "A A Bhange, H R Bhapkar",
                "Journal of Physics: Conference Series",
                2020,
                "1742-6588, 1742-6596",
                "https://iopscience.iop.org/journal/1742-6596",
                "https://iopscience.iop.org/article/10.1088/1742-6596/1743/1/012010/meta",
              ],
              [
                "PCCP of wheel graph family with null, chain, fan and cycle graph",
                "A A Bhange, H R Bhapkar",
                "Journal of Mathematical And Computational Science",
                2020,
                "1927-5307",
                "https://scik.org/index.php/jmcs/index",
                "https://scik.org/index.php/jmcs/article/view/5397",
              ],
              [
                "Robust fast finite time sliding mode control for industrial robot manipulators",
                "Shankar J. Gambhire",
                "International Journal of Dynamics",
                2018,
                "https://doi.org/10.1007/s40435-018-0476-1",
                "https://link.springer.com/",
                "https://link.springer.com/article/10.1007/s40435-018-0476-1",
              ],
              [
                "α , β Colouring of Graphs and Related Aspects",
                "A A Bhange, H R Bhapkar",
                "Journal of Emerging Technologies and Innovative Research",
                2018,
                "2349-5162",
                "https://jetir.org/index.html",
                "https://www.jetir.org/view?paper=JETIRBB06130",
              ],
              [
                "Tool Condition Monitoring using Vibration Signals during Hard Turning: A Review",
                "Govind Ghule, N H Ambhore, Satish Chinchanikar",
                "International conference on Advances in Thermal Systems, Materials and Design Engineering (ATSMDE2017)",
                2017,
                "",
                "https://www.ssrn.com/ssrn/",
                "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=3101977",
              ],
              [
                "PUBLIC RESPONSE ON SMART SOLID WASTE MANAGEMENT",
                "Nilambari Jadhav, S S Shinde",
                "7th International Conference on Recent Trends in Engineering, Science and Management",
                2017,
                "978-93-86171-12-2",
                "https://www.conferenceworld.in/",
                "http://data.conferenceworld.in/GSMCOE/P525-530.pdf",
              ],
              [
                "Smart Solid Waste Management Concept for Developing City",
                "Nilambari Jadhav, S S Shinde",
                "International Journal of Electronics, Electrical and Computational System",
                2017,
                "2348-117X",
                "https://journalseeker.researchbib.com/view/issn/2348-117X",
                "",
              ],
              [
                "Agro-Vision: Android based Solution for Regional Farming",
                "Rajesh S Jagatap, Vijay D Patil",
                "International Journal for Technological Research in Engineering (IJTRE)",
                2017,
                "2347-4718",
                "https://ijtre.com/",
                "https://ijtre.com/wp-content/uploads/2021/10/2017041125.pdf",
              ],
            ],
          ],
        },

        // Book chapters
        {
          title: "Book Chapter",
          tables: [
            [
              [
                "Name of the teacher",
                "Title of the book/chapters published",
                "Title of the paper",
                "Title of the proceedings of the conference",
                "Year of publication",
                "ISBN number of the proceeding",
                "Name of the publisher",
                "Link",
              ],
              [
                "Dr. A A Bhange",
                "Proceeding of First Doctoral Symposium on Natural Computing Research",
                "Relation between Perfect Colouring And Chromatic Number For Snake Graph Family",
                "First Doctoral Symposium on Natural Computing Research (DSNCR-2020)",
                "Mar-21",
                "978-981-33-4073-2",
                "Springer",
                "https://link.springer.com/chapter/10.1007/978-981-33-4073-2_15#:~:text=The%20perfect%20colouring%20of%20eight,%2C%20surveillance%20camera%20installation%2C%20etc.",
              ],
              [
                "Prof. Govind Ghule",
                "Advances in Engineering Design",
                "Ultrasonic Vibrations Assisted Turning (UAT): A Review",
                "Proceedings of FLAME 2020",
                "Apr-21",
                "978-981-33-4684-0",
                "Material Today",
                "https://link.springer.com/chapter/10.1007/978-981-33-4684-0_28#:~:text=Ultrasonically%20assisted%20turning%20(UAT)%20is,to%20produce%20a%20required%20high",
              ],
              [
                "Prof. Shankar J Gambhire",
                "International Smart Grid Workshop and Certificate Program (ISGWCP)",
                "Performance Comparison of Various Classical Controllers in LFC of Hydro-Thermal Power System with Time Delays",
                "10th IEEE International Conference on Smart Grid",
                "Jun-22",
                "978-1-6654-8604-0, 978-1-6654-8603-3, 978-1-6654-8605-7",
                "IEEE",
                "https://ieeexplore.ieee.org/document/9848690",
              ],
              [
                "Dr. Vrushali Rampure",
                "Computer Methods in Biomechanics and Biomedical Engineering: Imaging & Visualization",
                "Gastrointestinal tract disease segmentation and classification in wireless capsule endoscopy using intelligent deep learning model",
                "Computer Methods in Biomechanics and Biomedical Engineering: Imaging & Visualization",
                "Jul-22",
                "",
                "Taylor & Francis",
                "https://www.tandfonline.com/doi/abs/10.1080/21681163.2022.2099298?journalCode=tciv20",
              ],
              [
                "Prof. Govind Ghule",
                "Modern Machining Processes",
                "Modern Machining Processes",
                "",
                "2022",
                "978-93-5563-253-1",
                "Tech Knowledge",
                "https://techknowledgebooks.com/product/modern-machining-processes/",
              ],
              [
                "Dr A A Bhange",
                "Graph Learning and Network Science for Natural Language Processing",
                "Perfect Coloring by HB Color Matrix Algorithm Method",
                "",
                "Dec-22",
                "978-100-32-7264-9",
                "Taylor & Francis, CRC Press",
                "https://www.taylorfrancis.com/chapters/edit/10.1201/9781003272649-8/perfect-coloring-hb-color-matrix-algorithm-method-bhange-bhapkar",
              ],
              [
                "Prof. Seema Pundale",
                "Education and Society",
                "Maritime Labor convention in India and its role in nurturing active citizenship in indian seafarers",
                "",
                "Jan-23",
                "2278-6864",
                "Indian Institute of Education",
                "",
              ],
            ],
          ],
        },

        // Patents
        {
          title: "Patent",
          tables: [
            [
              [
                "Name of the Faculty/student author of the patent	",
                "Patent Number",
                "Date of Award",
                "Patent Awarding Agency",
              ],
              [
                "Prof. Govind Ghule",
                "R20222002811",
                "12 Sept. 22",
                "Intellectual Property  India",
              ],
            ],
          ],
        },
      ],
    },
  ];

  const course = FacultyResearchData[0]; // pick the first course
  const toggleSemester = (index) => {
    setActiveSem(index);
  };

  return (
    <div>
      <h1 className="title">Faculty Research</h1>
      <hr />
      {/* Semester Buttons */}
      <div className="page-content-btns">
        {course.research.map((sem, semIndex) => (
          <button
            key={semIndex}
            className={`page-content-btn ${activeSem === semIndex ? "active" : ""
              }`}
            onClick={() => toggleSemester(semIndex)}
          >
            {sem.title}
          </button>
        ))}
      </div>

      {/* Tables Section */}
      {activeSem !== null && (
        <div className="semester-content">
          <div>
            {course.research[activeSem].tables.map((table, tableIndex) => (
              <div key={tableIndex} className="page-content-table-wrapper">
                <table className="page-content-table" style={{ width: "100%" }}>
                  <tbody>
                    {table.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((cell, cellIndex) => {
                          const headerRow = table[0];
                          const headerTitle = headerRow[cellIndex];

                          const isLinkColumn =
                            headerTitle === "Link To Journal" ||
                            headerTitle === "Link To Article" ||
                            headerTitle === "Link";

                          return rowIndex === 0 ? (
                            <th key={cellIndex}>{cell}</th>
                          ) : (
                            <td key={cellIndex}>
                              {isLinkColumn ? (
                                cell ? (
                                  <button
                                    className="table-link-btn"
                                    onClick={() => window.open(cell, "_blank")}
                                  >
                                    Link
                                  </button>
                                ) : (
                                  "-"
                                )
                              ) : (
                                cell
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FacultyResearch;
